import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/moments-v2/moments-v2/src/app/signin/_components/screen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/moments-v2/moments-v2/src/utils/is-touch-device.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/moments-v2/moments-v2/src/utils/resize-image.ts");
